module.exports = __webpack_public_path__ + "img/page14-img1.11c61789.png";